import { Component, ViewEncapsulation } from '@angular/core';
import { CommonLibrary } from '../../core/common-library';
import { AdUpdateRequest } from '../DTOs/ad-update-request';
import { AdUploadResult } from '../DTOs/file-upload-result';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { MemberAdService } from '../member-ad.service';
import { MemberAd } from '../DTOs/member-ad';

@Component({
  selector: 'app-edit-ad-modal',
  templateUrl: './edit-ad-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditAdModalComponent {

    constructor(private pendingAdService: MemberAdService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbActiveModal) { }

    ad: MemberAd;
    adImage: File = null;
    imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    maxAdFileSize = 75000; // 75 KB
    invalidRunDate = false;
    invalidEndDate = false;
    invalidEnd = false;
    runDate;
    runDateParsed: Date;
    endDate;
    endDateParsed: Date;

    ngOnInit() {
        this.runDate = this.ad.runDate;
        this.endDate = this.ad.endDate;
    }

    resetModal() {
        this.adImage = null;
    }
    dismiss() {
        this.modalService.dismiss();
    }

    submitUpdatedAd() {
        this.runDateParsed = this.parseDate(this.runDate, true);
        this.endDateParsed = this.parseDate(this.endDate, false);
        if (this.invalidRunDate || this.runDateParsed == null) {
            return;
        }
        if (this.invalidEndDate || this.endDateParsed == null) {
            return;
        }

        var updateRequest = new AdUpdateRequest();
        updateRequest.adId = this.ad.adId;
        updateRequest.runDate = this.runDateParsed;
        updateRequest.endDate = this.endDateParsed;

        if (this.adImage == null) {
            this.updateMemberAd(updateRequest);
            return;
        }

        this.blockUI.start();
        this.uploadFile()
            .subscribe({
                next: (data: AdUploadResult) => {
                    updateRequest.newAdImageId = data.fileStorageId;
                    this.updateMemberAd(updateRequest);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    this.blockUI.stop();
                }
            });

    }

    updateMemberAd(req: AdUpdateRequest) {
        this.pendingAdService.updateMemberAd(req)
            .subscribe({
                next: (data) => {
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    this.blockUI.stop();
                    this.modalService.close();
                }
            });
    }

    updateAdImageFile(files: FileList) {
        if (!this.imageTypes.includes(files.item(0).type)) {
            this.notificationService.error("File is not a recognized image type.")
            return;
        }
        if (files.item(0).size > this.maxAdFileSize) {
            this.notificationService.error("File is larger than the maximum file size.");
            return;
        }
        this.adImage = files.item(0);
    }

    uploadFile() {
        const uploadData = new FormData();
        uploadData.append('mainImage', this.adImage, this.adImage.name);
        return this.pendingAdService.uploadAdFile(uploadData);
    }

    runDateChange() {
        var date = this.parseDate(this.runDate, true);
        if (this.invalidRunDate) {
            return;
        }
        var endDate = new Date(date);
        endDate.setDate(date.getDate() + 30);
        this.endDateParsed = endDate;
        this.endDate = CommonLibrary.formatDateIntoString(endDate);
    }

    parseDate(dateString: string, isRunDate: boolean) {
        if (!dateString) {
            return null;
        }
        const formats = [
            /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
            /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
            /^\d{2}-\d{2}-\d{4}$/, // MM-DD-YYYY
            /^\d{2}.\d{2}.\d{4}$/, // MM.DD.YYYY
        ];

        let date: Date;

        for (const format of formats) {
            if (format.test(dateString)) {
                if (format === formats[0]) { // YYYY-MM-DD
                    date = new Date(dateString);
                } else if (format === formats[1]) { // MM/DD/YYYY
                    const [month, day, year] = dateString.split('/').map(Number);
                    date = new Date(year, month - 1, day);
                } else if (format === formats[2]) { // MM-DD-YYYY
                    const [month, day, year] = dateString.split('-').map(Number);
                    date = new Date(year, month - 1, day);
                } else if (format === formats[3]) { // MM.DD.YYYY
                    const [month, day, year] = dateString.split('.').map(Number);
                    date = new Date(year, month - 1, day);
                }

                break;
            }
        }
        if (!date || isNaN(date.getTime())) {
            if (isRunDate) this.invalidRunDate = true;
            else this.invalidEndDate = true;
        }
        else {
            if (isRunDate) this.invalidRunDate = false;
            else this.invalidEndDate = false;
        }

        return date;
    }

    protected readonly CommonLibrary = CommonLibrary;

}
